const Layout = ({ children }) => {
  return (
    <div className="flex">
      <div className="flex-1 ml-[280px] min-h-screen bg-gray-100">
        {children}
      </div>
    </div>
  );
};

export default Layout;